import { useState } from "react";

const serviceOptions = [
  "各平台直播", "展場活動", "SG / 展場人員", "舞團表演",
  "活動策劃", "網紅業配代言", "網紅形象廣告", "網紅策劃聯盟",
  "異業合作", "拍照攝影紀錄",
];

export default function BusinessContactForm() {
  const [selected, setSelected] = useState<string[]>([]);
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [charCount, setCharCount] = useState(0);

  const toggleService = (s: string) => {
    setSelected((prev) =>
      prev.includes(s) ? prev.filter((x) => x !== s) : [...prev, s]
    );
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (selected.length === 0) return;
    setSubmitting(true);
    const form = e.currentTarget;
    const data = new URLSearchParams();
    data.append("name", (form.elements.namedItem("name") as HTMLInputElement).value);
    data.append("email", (form.elements.namedItem("email") as HTMLInputElement).value);
    data.append("phone", (form.elements.namedItem("phone") as HTMLInputElement).value);
    data.append("company", (form.elements.namedItem("company") as HTMLInputElement).value);
    data.append("services", selected.join("、"));
    data.append("budget", (form.elements.namedItem("budget") as HTMLSelectElement).value);
    data.append("message", (form.elements.namedItem("message") as HTMLTextAreaElement).value);
    try {
      await fetch("https://readdy.ai/api/form/d7bvl3ulfkej60p1k980", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: data.toString(),
      });
      setSubmitted(true);
    } catch {
      setSubmitted(true);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section id="biz-form" className="py-20 bg-stone-50">
      <div className="max-w-3xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1 rounded-full bg-red-50 text-red-600 text-xs font-semibold tracking-widest uppercase mb-4">
            Contact Us
          </span>
          <h2 className="text-3xl md:text-4xl font-black text-gray-900 mb-3" style={{ fontFamily: "'Noto Serif TC', serif" }}>
            合作洽談表單
          </h2>
          <p className="text-gray-500 text-sm">填寫後我們將在 24 小時內與你聯繫</p>
        </div>

        {submitted ? (
          <div className="bg-white rounded-3xl p-14 text-center">
            <div className="w-20 h-20 flex items-center justify-center rounded-full bg-green-100 mx-auto mb-6">
              <i className="ri-check-double-line text-4xl text-green-600" />
            </div>
            <h3 className="text-2xl font-black text-gray-900 mb-3" style={{ fontFamily: "'Noto Serif TC', serif" }}>
              收到你的合作提案了！
            </h3>
            <p className="text-gray-500 text-sm leading-relaxed">
              感謝你的聯繫，我們會在 24 小時內透過 Email 或電話與你聯繫。<br />
              也歡迎直接私訊我們的 Instagram！
            </p>
            <a
              href="https://www.instagram.com/rappy.meme/"
              target="_blank"
              rel="nofollow noreferrer"
              className="inline-flex items-center gap-2 mt-6 px-6 py-2.5 rounded-full bg-red-600 text-white text-sm font-semibold hover:bg-red-700 transition-all cursor-pointer whitespace-nowrap"
            >
              <i className="ri-instagram-line" />
              私訊 Instagram
            </a>
          </div>
        ) : (
          <form
            data-readdy-form
            id="biz-contact-form"
            onSubmit={handleSubmit}
            className="bg-white rounded-3xl p-8 md:p-10 flex flex-col gap-6"
          >
            {/* Basic Info */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-1.5">姓名 <span className="text-red-500">*</span></label>
                <input
                  type="text"
                  name="name"
                  required
                  placeholder="你的姓名"
                  className="w-full px-4 py-2.5 rounded-xl border border-gray-200 text-sm text-gray-800 focus:outline-none focus:border-red-400 transition-colors"
                />
              </div>
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-1.5">Email <span className="text-red-500">*</span></label>
                <input
                  type="email"
                  name="email"
                  required
                  placeholder="your@email.com"
                  className="w-full px-4 py-2.5 rounded-xl border border-gray-200 text-sm text-gray-800 focus:outline-none focus:border-red-400 transition-colors"
                />
              </div>
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-1.5">聯絡電話</label>
                <input
                  type="tel"
                  name="phone"
                  placeholder="0912-345-678"
                  className="w-full px-4 py-2.5 rounded-xl border border-gray-200 text-sm text-gray-800 focus:outline-none focus:border-red-400 transition-colors"
                />
              </div>
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-1.5">公司 / 品牌名稱</label>
                <input
                  type="text"
                  name="company"
                  placeholder="公司或品牌名稱"
                  className="w-full px-4 py-2.5 rounded-xl border border-gray-200 text-sm text-gray-800 focus:outline-none focus:border-red-400 transition-colors"
                />
              </div>
            </div>

            {/* Service Selection */}
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-3">
                感興趣的服務項目 <span className="text-red-500">*</span>
                <span className="text-gray-400 font-normal ml-2">（可複選）</span>
              </label>
              <div className="flex flex-wrap gap-2">
                {serviceOptions.map((s) => (
                  <button
                    key={s}
                    type="button"
                    onClick={() => toggleService(s)}
                    className={`px-4 py-2 rounded-full text-sm font-medium border transition-all cursor-pointer whitespace-nowrap ${
                      selected.includes(s)
                        ? "bg-red-600 text-white border-red-600"
                        : "bg-white text-gray-600 border-gray-200 hover:border-red-300 hover:text-red-600"
                    }`}
                  >
                    {selected.includes(s) && <i className="ri-check-line mr-1" />}
                    {s}
                  </button>
                ))}
              </div>
              {selected.length === 0 && (
                <p className="text-xs text-gray-400 mt-2">請至少選擇一項服務</p>
              )}
            </div>

            {/* Budget */}
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-1.5">預算範圍</label>
              <select
                name="budget"
                className="w-full px-4 py-2.5 rounded-xl border border-gray-200 text-sm text-gray-800 focus:outline-none focus:border-red-400 transition-colors bg-white cursor-pointer"
              >
                <option value="">請選擇預算範圍</option>
                <option value="5000以下">NT$ 5,000 以下</option>
                <option value="5000-20000">NT$ 5,000 – 20,000</option>
                <option value="20000-50000">NT$ 20,000 – 50,000</option>
                <option value="50000-100000">NT$ 50,000 – 100,000</option>
                <option value="100000以上">NT$ 100,000 以上</option>
                <option value="面議">面議</option>
              </select>
            </div>

            {/* Message */}
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-1.5">
                合作說明 / 需求描述
                <span className="text-gray-400 font-normal ml-2">（{charCount}/500）</span>
              </label>
              <textarea
                name="message"
                rows={5}
                maxLength={500}
                placeholder="請描述你的合作需求、活動規模、時間等細節..."
                onChange={(e) => setCharCount(e.target.value.length)}
                className="w-full px-4 py-3 rounded-xl border border-gray-200 text-sm text-gray-800 focus:outline-none focus:border-red-400 transition-colors resize-none"
              />
            </div>

            <button
              type="submit"
              disabled={submitting || selected.length === 0}
              className="w-full py-3.5 rounded-xl bg-red-600 text-white font-bold text-sm hover:bg-red-700 transition-all cursor-pointer whitespace-nowrap disabled:opacity-50 flex items-center justify-center gap-2"
            >
              {submitting ? (
                <><i className="ri-loader-4-line animate-spin" /> 送出中...</>
              ) : (
                <><i className="ri-send-plane-fill" /> 送出合作提案</>
              )}
            </button>
          </form>
        )}
      </div>
    </section>
  );
}
